module.exports = __webpack_public_path__ + "img/nlgc2.c107c88b.jpg";